import React from 'react';
import {Divider, Drawer, SwipeableDrawer, Toolbar} from '@mui/material';
import {Close} from '@mui/icons-material';
import {useRecoilValue} from 'recoil';
import {bidmiiProReferralBannerOpenState} from '../../../../recoil/dialogs/DialogsRecoil';
import {theme} from '../../../../Theme';

interface IProps {
  width: number;
  hidden: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  children?: React.ReactNode;
}

export const NavigationDrawer: React.FC<IProps> = (props) => {
  const referralBannerOpen = useRecoilValue(bidmiiProReferralBannerOpenState);

  return (
    <>
      {props.width > 600 ? (
        <Drawer
          id="desktop-drawer"
          variant="persistent"
          open={props.open}
          onClose={() => props.setOpen(false)}
          style={{
            display: props.hidden ? 'none' : 'inherit',
            height: '100%',
          }}
          PaperProps={{
            style: {borderRight: `1px solid ${theme.palette.gray.medium}`},
          }}>
          {referralBannerOpen && <Toolbar style={{minHeight: 56}} />}
          <Toolbar />
          {props.children}
        </Drawer>
      ) : (
        <SwipeableDrawer
          open={props.open}
          onClose={() => props.setOpen(false)}
          onOpen={() => props.setOpen(true)}>
          <Toolbar>
            <Close
              onClick={() => props.setOpen(false)}
              style={{marginLeft: 'auto'}}
            />
          </Toolbar>
          <Divider style={{margin: '4px 0'}} />
          <div
            style={{
              height: '100%',
              overflowY: 'scroll',
              padding: 0,
            }}>
            {props.children}
          </div>
        </SwipeableDrawer>
      )}
    </>
  );
};
